import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";

const BankTable = ({ permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [branchData, setBranchData] = useState([]);
  const [loading, setLoading] = useState(false);
  const moduleId = location.state?.ModuleID;
  console.log(moduleId);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchbranchData = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);
    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const result = await fetchData("getallbank", {}, "GET");

      if (result) {
        const branch = result.data || [];
        branch.sort((a, b) => a.lender_name.localeCompare(b.lender_name));
        setBranchData(branch);
      }
    } catch (error) {
      console.error("Error fetching bank data:", error);
   
    } finally {
      Swal.close();
    }
  };

  const toggleStatus = async (Id) => {
    const formData = new FormData();
    formData.append("id", Id);
    formData.append("userId", userId);
    formData.append("moduleId", M_id); // Send ID in form data

    const result = await fetchFormData(`bank/toggle-status`, formData, "POST");

    if (result && result.code === 200) {
      await fetchbranchData();
      if (result?.status === 1) {
        topTost({
          title: "Status updated successfully: Active",
          icon: "success",
        });
      } else {
        topTost({
          title: "Status updated successfully: Deactive",
          icon: "success",
        });
      }
    } else {
      console.error("Failed to toggle state status:", result?.message);
    }
  };

  const columns = [
    ...(permission?.pf_edit === 1 || permission?.pf_status === 1
      ? [
          {
            accessorKey: "actions",
            header: () => "Actions",
            cell: ({ row }) => {
              const id = row.original.id;
              const is_active = row.original.status;
              return (
                <div className="hstack gap-2 justify-content-end">
                  {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() =>
                        navigate(`/master/edit-lender/${id}?id=${M_id}`)
                      }
                    >
                      <FiEdit3 size={16} />
                    </span>
                  )}
                  {permission?.pf_status === 1 &&
                    (is_active === 1 ? (
                      <MdThumbUp
                        className="cursor-pointer text-success"
                        onClick={() => toggleStatus(id)}
                      />
                    ) : (
                      <MdThumbDown
                        className="cursor-pointer text-secondary"
                        onClick={() => toggleStatus(id)}
                      />
                    ))}
                </div>
              );
            },
            meta: {
              headerClassName: "width-30",
              exportable: false,
            },
          },
        ]
      : []),

    {
      accessorKey: "lender_name",
      header: () => "Lender name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "status",
      header: () => "Status",
      cell: (info) => {
        const val = info.getValue(); 
        const isActive = val === 1;

        const label = isActive ? "Active" : "Deactive";
        const styles = {
          backgroundColor: isActive ? "#cce5ff" : "#fff3cd", 
          color: isActive ? "#004085" : "#856404", 
          padding: "4px 10px",
          display: "inline-block",
          fontWeight: "bold",
          fontSize: "12px",
          textAlign: "center",
        };

        return <span style={styles}>{label}</span>;
      },
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    fetchbranchData();
  }, []);
  return (
    <>
      <Table data={branchData} columns={columns} />
    </>
  );
};

export default BankTable;
